import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const VatExemptionMentionSectionWrapper = styled.div`
  section {
    padding-top: ${Spacing.S8};
  }
`

export const VatExemptionMentionSchemeDrivesList = styled.ul`
  padding-left: ${Spacing.S20};
  list-style-type: disc;
`
